define(function(require){
    'use strict';

    var _ = require('underscore');
    var Marionette  = require('marionette');
    var Template    = require('text!popovers/staff_call_to_contact/template/body.tpl').default;

    return Marionette.ItemView.extend({
        // Template
        template : Template,

        /*
        *   function serializeData()
        *   Generate template data
        *   @return {object} templateData
        */
        serializeData: function(){
            var staff = _.sortBy(this.collection.toJSON(), function(obj) {
                return obj.profile_type;
            });
            return {
                staff: staff
            };
        }
    });
});
